import { Helmet } from "react-helmet-async";

import { View403 } from "src/sections/error";

// ----------------------------------------------------------------------

export default function Page403() {
  return (
    <>
      <Helmet>
        <title> Radical Health | Harley</title>
      </Helmet>

      <View403 />
    </>
  );
}
